import i18n from '../i18n';

export function getLocale() {
  return i18n.language === 'sv' ? 'sv-SE' : 'en-GB';
}

export function formatDate(dateStr) {
  if (!dateStr) return '';
  const d = new Date(dateStr);
  if (isNaN(d.getTime())) return dateStr;
  if (i18n.language === 'sv') {
    const dd = String(d.getDate()).padStart(2, '0');
    const mm = String(d.getMonth() + 1).padStart(2, '0');
    return `${dd}-${mm}-${d.getFullYear()}`;
  }
  return d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
}

export function formatMonthYear(year, month) {
  const d = new Date(year, month - 1, 1);
  return d.toLocaleDateString(getLocale(), { month: 'long', year: 'numeric' });
}

export function formatMonthName(year, month) {
  const d = new Date(year, month - 1, 1);
  return d.toLocaleDateString(getLocale(), { month: 'long' });
}

export function getShortDayNames() {
  const locale = getLocale();
  const days = [];
  for (let i = 1; i <= 7; i++) {
    const d = new Date(2024, 0, i);
    days.push(d.toLocaleDateString(locale, { weekday: 'short' }));
  }
  return days;
}

export function formatSEK(amount) {
  if (amount == null) return '';
  return new Intl.NumberFormat(getLocale(), {
    style: 'currency',
    currency: 'SEK',
    minimumFractionDigits: 0,
    maximumFractionDigits: 2,
  }).format(amount);
}

export function formatNumber(n, decimals = 2) {
  if (n == null) return '';
  return new Intl.NumberFormat(getLocale(), {
    minimumFractionDigits: 0,
    maximumFractionDigits: decimals,
  }).format(n);
}
